import React from 'react'

import { useCashoutsAllData } from '../../hooks/use-cashouts-all-data'
import useUserContext from '../../../../hooks/useUserContext'
import { VerifyIdentity, needsIdentityVerification } from '../verify-identity'

import Loading from '../../../Loading'
import { Credit } from '../credit'
import { Debit } from '../debit'
import { Spei } from '../spei'
import { Store } from '../store'
import { SpeiOpenpay } from '../spei-openpay'

export const ActiveView = () => {
  const { isLoading, cashoutAccounts, incode } = useCashoutsAllData()
  const { userData } = useUserContext()

  if (isLoading) return <Loading label="Cargando información" />

  const renderCashoutForm = () => {
    if (!cashoutAccounts.lastPurchase) return <Store />

    if (cashoutAccounts.lastPurchase.gateway === 'openpay' && cashoutAccounts.lastPurchase.type === 'spei') {
      return <SpeiOpenpay />
    }

    switch (cashoutAccounts.lastPurchase.type) {
      case 'credit':
        return <Credit />
      case 'debit':
        return <Debit />
      case 'spei':
        return <Spei />
      default:
        return <Store />
    }
  }

  return (
    <div>
      {needsIdentityVerification(userData, incode.incodeEnabled) ? <VerifyIdentity /> : renderCashoutForm()}
    </div>
  )
}
